import { render, staticRenderFns } from "./ResumeAccountsReceivable.vue?vue&type=template&id=5f159a84&scoped=true"
import script from "./ResumeAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./ResumeAccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./ResumeAccountsReceivable.vue?vue&type=style&index=0&id=5f159a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f159a84",
  null
  
)

export default component.exports